import React from 'react'
import { motion } from 'framer-motion'

const MobileHeader: React.FC = () => {
  return (
    <motion.header 
      className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md border-b border-gray-200 safe-area-top"
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="flex items-center justify-center px-4 py-3">
        <motion.div 
          className="flex items-center space-x-2"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          <div className="w-8 h-8 rounded-lg overflow-hidden">
            <img src="/app-icon.png" alt="漫时光" className="w-full h-full object-cover" />
          </div>
          <div>
            <h1 className="text-lg font-bold text-gray-900">漫时光</h1>
            <p className="text-xs text-gray-500">版本迁移指南</p>
          </div>
        </motion.div>
      </div>
    </motion.header>
  )
}

export default MobileHeader
